import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createDefer } from '@/utils';
import { createContext, useContext, useMemo, useState } from 'react';
import { TokenPickerDialog } from './TokenPickerDialog';
const ERC20Context = createContext(null);
export const usePickERC20 = () => {
    return useContext(ERC20Context).pickERC20;
};
let id = 0;
export const ERC20Provider = ({ children }) => {
    const [tasks, setTasks] = useState([]);
    const removeTask = (task) => {
        setTasks((list) => list.filter((t) => t !== task));
    };
    const contextValue = useMemo(() => {
        return {
            pickERC20: async (options) => {
                const [promise, resolve, reject] = createDefer();
                id += 1;
                setTasks((taskList) => [
                    ...taskList,
                    {
                        id,
                        promise,
                        resolve,
                        reject,
                        options: options,
                    },
                ]);
                return promise;
            },
        };
    }, []);
    return (_jsxs(ERC20Context.Provider, { value: contextValue, children: [children, tasks.map((task) => (_jsx(TokenPickerDialog, { open: true, onClose: () => removeTask(task), exclude: task.options?.exclude, onPick: (token) => {
                    task.resolve(token);
                    removeTask(task);
                } }, task.id)))] }));
};
